"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _heroFeatureBlock = _interopRequireDefault(require("./hero-feature-block"));
var _heroBackground = _interopRequireDefault(require("./hero-background"));
var _heroBrand = _interopRequireDefault(require("./hero-brand.props/hero-brand.defaultProps"));
var _heroBrand2 = _interopRequireDefault(require("./hero-brand.props/hero-brand.propTypes"));
var _heroBrandV = _interopRequireDefault(require("../styles/hero-brand-v2.css"));
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp;
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var ctaData = function ctaData(data) {
  return {
    url: handleNestedProp(data, 'data.URL'),
    label: handleNestedProp(data, 'data.label'),
    priority: handleNestedProp(data, 'data.priority'),
    ctaTheme: handleNestedProp(data, 'data.theme'),
    openNewTab: handleNestedProp(data, 'data.openNewTab'),
    icon: handleNestedProp(data, 'data.icon'),
    ctaType: handleNestedProp(data, 'data.ctaType')
  };
};
var checkForMobileAgent = function checkForMobileAgent() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};
var HeroBrandV2 = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HeroBrandV2, _React$Component);
  HeroBrandV2.resourceType = function resourceType() {
    return 'Standard_HeroV2_1_0_0';
  };
  function HeroBrandV2(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleWindowResize = function () {
      var width = 0;
      var isMobileAgent = false;
      if (typeof window !== 'undefined') {
        width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
        isMobileAgent = checkForMobileAgent();
      }
      if (width <= 768 && isMobileAgent) {
        _this.setState({
          isMobile: true
        });
      } else {
        _this.setState({
          isMobile: false
        });
      }
    };
    _this.state = {
      isMobile: false
    };
    return _this;
  }
  var _proto = HeroBrandV2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      _this$props$config = _this$props.config,
      market = _this$props$config.market,
      currencyFormat = _this$props$config.currencyFormat,
      data = _this$props.data,
      currentPath = _this$props.currentPath;
    if (market.toLowerCase() === 'mx' && data && data.price && data.price.value && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'view_item',
        view_itemdata: [{
          currency: currencyFormat,
          value: data.price.value,
          item: data.heading2,
          layer: currentPath.substring(1).replace(/\//g, ' :: ')
        }]
      });
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleWindowResize);
      this.handleWindowResize();
    }
  };
  _proto.render = function render() {
    var _clsx, _clsx2, _clsx3;
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme,
      defaultData = _this$props2.defaultData,
      config = _this$props2.config;
    var isMobile = this.state.isMobile;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: ((0, _clsx4["default"])(theme['container-fluid'], applyDarkTheme(data, theme)), _heroBrandV["default"].heroContainer)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_heroBrandV["default"].heroWrapper, theme.row, (_clsx = {}, _clsx[_heroBrandV["default"][componentData.textBlockPosition]] = _heroBrandV["default"][componentData.textBlockPosition], _clsx))
    }, /*#__PURE__*/_react["default"].createElement(_heroBackground["default"], {
      data: componentData,
      theme: theme,
      config: config,
      isMobile: isMobile
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_heroBrandV["default"].featuresCtaWrapper, (_clsx2 = {}, _clsx2[_heroBrandV["default"].greyBg] = componentData.featureBlock, _clsx2[_heroBrandV["default"].darkBg] = componentData.textBlockPosition === 'leftbackground' || isMobile, _clsx2))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _heroBrandV["default"].featureBlockContainer
    }, componentData.featureBlock && /*#__PURE__*/_react["default"].createElement(_heroFeatureBlock["default"], {
      theme: theme,
      data: componentData,
      disclaimerData: handleNestedProp(componentData, 'componentData.disclaimerData')
    })), data.cta && isMobile && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(applyDarkTheme(data, theme), _heroBrandV["default"].ctaWrapper, _heroBrandV["default"].mobCta, (_clsx3 = {}, _clsx3[_heroBrandV["default"].centerCta] = data.textBlockPosition === 'center', _clsx3))
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: ctaData(handleNestedProp(componentData, 'data.cta')),
      "data-section": componentData.heading1,
      classes: [applyDarkTheme(componentData, theme) + " " + (componentData.cta.priority === 'lowIcon' && _heroBrandV["default"].adjustIconPosition)]
    })))));
  };
  return HeroBrandV2;
}(_react["default"].Component);
HeroBrandV2.displayName = 'HeroBrand-V2';
HeroBrandV2.defaultProps = {
  data: _heroBrand["default"],
  defaultData: _heroBrand["default"],
  config: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(HeroBrandV2));
exports["default"] = _default;